import { computeAutoBonus } from "@/lib/bonusConfig";
import { isBaseSalaryItem, hasBaseFlag } from "@/lib/baseSalary";

// Computes proventos/descontos/líquido for a payroll line, applying the same
// rules the Folha uses: disabled items are excluded, "Bônus (auto)" items are
// valued from the period deliveries, and individual benefits/discounts are added.
// Salário Base da linha: override individual > salário da categoria na base > global da categoria (config).
export function withResolvedSalary(line, { configById = {}, override = null, baseValue = null, n = 1, baseFlags = {} }) {
  let done = false;
  const anyFlag = hasBaseFlag(line?.items, baseFlags);
  const items = (line?.items || []).map((it) => {
    if (done || !isBaseSalaryItem(it, { flags: baseFlags, anyFlag, label: configById[it.id]?.label, isSalary: (configById[it.id]?.kind ?? it.kind) === "salary" })) return it;
    done = true;
    const global = configById[it.id]?.value != null ? Number(configById[it.id].value) : (Number(it.value) || 0) / n;
    const v = override != null ? override : baseValue != null ? baseValue : global;
    return { ...it, value: v * n };
  });
  return { ...line, items };
}

export function lineBreakdown(line, opts = {}) {
  const { disabled = {}, auto = {}, mins = {}, tiers = [], deliveries = 0, individual = [], tax = {}, quinzenaItems = {}, period = "mensal", contract_type = "clt" } = opts;
  const isAuto = (it) => auto[it.id] || it.source === "bonus_auto";
  const isPj = String(contract_type || "").toLowerCase() === "pj";
  // Componente restrito a uma quinzena (1|2) só entra nela; sem marcação = Ambas. Mensal inclui todos.
  const inQuinzena = (it) => period === "mensal" || !quinzenaItems[it.id] || Number(quinzenaItems[it.id]) === Number(period);
  const items = (line?.items || [])
    .filter((it) => !disabled[it.id] && inQuinzena(it) && !(isPj && isAuto(it)))
    .map((it) => {
      if (!isAuto(it)) return it;
      const { value } = computeAutoBonus(deliveries, mins, tiers, contract_type);
      return { ...it, value, is_discount: false };
    });
  const prov = items.filter((x) => !x.is_discount).reduce((a, x) => a + (Number(x.value) || 0), 0);
  // Custo da empresa: descontos (Desconto) subtraem do Custo Líquido.
  // Impostos (tax) são retidos do colaborador e repassados ao governo: nunca impactam.
  let desc = items.filter((x) => x.is_discount && !tax[x.id]).reduce((a, x) => a + (Number(x.value) || 0), 0);
  (individual || []).forEach((b) => {
    const v = Number(b.value) || 0;
    if (b.kind === "discount") desc += v; // descontos individuais sempre impactam o custo
  });
  const provIndiv = (individual || []).reduce((a, b) => a + (b.kind === "discount" ? 0 : (Number(b.value) || 0)), 0);
  return { prov: prov + provIndiv, desc, net: prov + provIndiv - desc };
}
